/* Start Section nwkw_nkd_link_grid_NbTGyj */
document.addEventListener('DOMContentLoaded',function(){var Swipes=new Swiper('.section-template--nwkw_nkd_link_grid_NbTGyj .swiper',{loop:false,slidesPerView:3,spaceBetween:20});});
/* End Section nwkw_nkd_link_grid_NbTGyj */
/* Start Section nwkw_nkd_hero_banner_zYgM6T */
document.addEventListener("DOMContentLoaded",function(){const videoPlayers=document.querySelectorAll("video-player");videoPlayers.forEach((player,index)=>{const video=player.querySelector("video");const transcript=player.querySelector(".video-transcript");if(video&&transcript){let transcriptId=transcript.id;if(!transcriptId){transcriptId=`video-transcript-${index+1}`;transcript.id=transcriptId;}
video.setAttribute("aria-describedby",transcriptId);const altText=video.getAttribute("alt")||video.getAttribute("aria-label")||"Video with transcript available.";video.setAttribute("aria-label",altText);video.setAttribute("alt",altText);if(!video.hasAttribute("tabindex")){video.setAttribute("tabindex","0");}}});});document.addEventListener('DOMContentLoaded',()=>{const timerElement=document.querySelector('.timer_countdown_time_text_class_section p');if(!timerElement)return;function parseEndTime(){const endDateText=timerElement.innerText;const[day,month,year,hour,minute,second]=endDateText.split(/[- :]/);const endDate=new Date(`${month}-${day}-${year}${hour}:${minute}:${second}`);return endDate.getTime();}
let endTime=parseEndTime();function getNewEndTime(){return new Date().getTime()+48*60*60*1000;}
function updateCountdown(){const now=new Date().getTime();let remainingTime=endTime-now;if(remainingTime<=0){if(endTime<(now+24*60*60*1000)){endTime=now+24*60*60*1000;}else{endTime=getNewEndTime();}
remainingTime=endTime-now;}
const days=Math.floor(remainingTime/(1000*60*60*24));const hours=Math.floor((remainingTime/(1000*60*60))%24);const minutes=Math.floor((remainingTime/(1000*60))%60);const seconds=Math.floor((remainingTime/1000)%60);timerElement.innerText=`${hours}:${minutes}:${seconds}`;}
setInterval(updateCountdown,1000);updateCountdown();});
/* End Section nwkw_nkd_hero_banner_zYgM6T */
/* Start Section nwkw_nkd_grid_products_list_DmULXj */
function updateGridRows1(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_DmULXj';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows1);window.addEventListener('resize',debounce(updateGridRows1,100));
/* End Section nwkw_nkd_grid_products_list_DmULXj */
/* Start Section nwkw_nkd_grid_products_list_fmxAPg */
function updateGridRows2(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_fmxAPg';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=3;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows2);window.addEventListener('resize',debounce(updateGridRows2,100));
/* End Section nwkw_nkd_grid_products_list_fmxAPg */
/* Start Section nwkw_nkd_grid_products_list_cD9FLW */
function updateGridRows3(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_cD9FLW';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows3);window.addEventListener('resize',debounce(updateGridRows3,100));
/* End Section nwkw_nkd_grid_products_list_cD9FLW */
/* Start Section nwkw_nkd_grid_products_list_XBF9Uk */
function updateGridRows4(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_XBF9Uk';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows4);window.addEventListener('resize',debounce(updateGridRows4,100));
/* End Section nwkw_nkd_grid_products_list_XBF9Uk */
/* Start Section nwkw_nkd_grid_products_list_N9hBBf */
function updateGridRows5(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_N9hBBf';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows5);window.addEventListener('resize',debounce(updateGridRows5,100));
/* End Section nwkw_nkd_grid_products_list_N9hBBf */
/* Start Section nwkw_nkd_grid_products_list_KBiACX */
function updateGridRows6(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_KBiACX';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows6);window.addEventListener('resize',debounce(updateGridRows6,100));
/* End Section nwkw_nkd_grid_products_list_KBiACX */
/* Start Section nwkw_nkd_grid_products_list_AeKDaG */
function updateGridRows7(){const sectionSelector='.section-template--nwkw_nkd_grid_products_list_AeKDaG';const allGridDiv=document.querySelectorAll(`${sectionSelector} .product_container-detials`);const topGridDiv=document.querySelector(`${sectionSelector} .swiper-wrapper`);const rowInWeb=4;const rowInMeb=2;const allChilds=Array.from(topGridDiv.children);const chunkArray=(arr,size)=>Array.from({length:Math.ceil(arr.length/size)},(_,i)=>arr.slice(i*size,i*size+size));const calcAndSetHeights=(containers)=>{if(!containers.length)return;let maxChildren=Math.max(...containers.map(div=>div.children.length));const allHeight=Array.from({length:maxChildren},()=>0);containers.forEach(div=>{div.style.gridTemplateRows='none';Array.from(div.children).forEach((child,idx)=>{allHeight[idx]=Math.max(allHeight[idx],child.offsetHeight);});});const rowHeights=allHeight.map(h=>`${h}px`).join(' ');containers.forEach(div=>{div.style.gridTemplateRows=rowHeights;});};if(topGridDiv.classList.contains("swiper-initialized")){calcAndSetHeights(Array.from(allGridDiv));}else{const groups=window.innerWidth>767?chunkArray(allChilds,rowInWeb):chunkArray(allChilds,rowInMeb);groups.forEach(group=>{const productDetailsArray=group.map(ele=>ele.querySelector('.product_container-detials')).filter(Boolean);calcAndSetHeights(productDetailsArray);});}}
function debounce(func,wait){let timeout;return function(...args){clearTimeout(timeout);timeout=setTimeout(()=>func.apply(this,args),wait);};}
document.addEventListener('DOMContentLoaded',updateGridRows7);window.addEventListener('resize',debounce(updateGridRows7,100));
/* End Section nwkw_nkd_grid_products_list_AeKDaG */
document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function (e) {
            e.preventDefault();

            document.querySelector(this.getAttribute('href')).scrollIntoView({
                behavior: 'smooth'
            });
        });
    });
});
(function () {
  // Check if the custom element is already defined
  if (!customElements.get('video-player')) {
    class VideoPlayer extends HTMLElement {
      constructor() {
        super();
        this.videos = this.querySelectorAll('video');
        this.videoWeb = this.videos[0];
        this.videoMob = this.videos[1];
        this.playBtn = this.querySelector('.play-btn');
        this.soundBtn = this.querySelector('.mute-btn');
        this.disableClick = this.dataset.click;

        if (this.disableClick) {
          this.initEventListeners();
        }
      }

      initEventListeners() {
        this.videos.forEach(video => {
          video.addEventListener('click', () => this.togglePlay(video));
          video.addEventListener('ended', () => this.handleVideoEnded(video));
        });

        if (this.playBtn) {
          this.playBtn.addEventListener('click', () => this.handlePlayButton());
        }

        if (this.soundBtn) {
          this.soundBtn.addEventListener('click', () => this.toggleMute());
        }

        window.addEventListener('resize', () => this.handleResize());
      }

      togglePlay(video) {
        if (video.paused) {
          this.playVideo(video);
        } else {
          this.pauseVideo(video);
        }
      }

      playVideo(video) {
        this.videos.forEach(otherVideo => {
          if (otherVideo !== video) {
            otherVideo.pause();
            otherVideo.muted = true;
          }
        });

        video.muted = false;
        video.play();
        this.classList.add('played');

        // ✅ Hide the Play button
        if (this.playBtn) {
          this.playBtn.style.opacity = '0';
          this.playBtn.style.pointerEvents = 'none'; // Prevent clicking while hidden
        }

        if (this.soundBtn) {
          this.soundBtn.classList.remove('active');
        }
      }

      pauseVideo(video) {
        video.pause();
        video.muted = true;
        this.classList.remove('played');

        // ✅ Show the Play button again
        if (this.playBtn) {
          this.playBtn.style.opacity = '1';
          this.playBtn.style.pointerEvents = 'auto';
        }

        if (this.soundBtn) {
          this.soundBtn.classList.add('active');
        }
      }
      pauseAllVideo() {
        this.videos.forEach(video => {
          this.pauseVideo(video)
        });
      }

      handlePlayButton() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) this.togglePlay(targetVideo);
      }

      toggleMute() {
        const targetVideo = window.innerWidth < 749 && this.videoMob ? this.videoMob : this.videoWeb;
        if (targetVideo) {
          targetVideo.muted = !targetVideo.muted;
          this.soundBtn.classList.toggle('active', targetVideo.muted);
        }
      }

      handleResize() {
        if (!this.videoMob) return;

        const isMobile = window.innerWidth < 749;
        const targetVideo = isMobile ? this.videoMob : this.videoWeb;

        this.videos.forEach(video => {
          video.pause();
          video.muted = true;
        });

        targetVideo.play();
        targetVideo.muted = false;
        targetVideo.pause();
      }

      handleVideoEnded(video) {
        if (!video.loop) {
          this.classList.remove('played');
          video.muted = true;

          // ✅ Show the Play button again
          if (this.playBtn) {
            this.playBtn.style.opacity = '1';
            this.playBtn.style.pointerEvents = 'auto';
          }
        }
      }
    }

    // Define the custom element
    customElements.define('video-player', VideoPlayer);
  }
})();
if (!customElements.get('carousel-slider')) {
  class CarouselSlider extends HTMLElement {
    constructor() {
      super();
      this.activeIndex = 0;
      this.has_pre_injected_media = false;
    }

    connectedCallback() {
      this.init();
      
      // If a selected media is pre-injected, set that in has_pre_injected_media.
      // In that case, in gotoSlide, we will use index + 1.
      const selectedMediaEl = this.mainMedia.querySelector('[data-wwai-selected-variant-product-media]');
      if (selectedMediaEl) {
        this.has_pre_injected_media = true;
      }
    }

    init() {
      this.cacheElements();
      this.bindEvents();
      // We dont perform scroll here, since either we have 
      // pre injected media or we will use index = 0 or we will call gotoSlide from 
      // functionality generator.
      // this.scrollToMediaItem(this.activeIndex);
    }

    cacheElements() {
      this.mainMedia = this.querySelector('main-slider');
      this.thumbSlider = this.querySelector('thumb-slider');
      this.thumbVertical = this.thumbSlider?.dataset.vartical;
      this.pagenation = this.querySelector('pagenation');
      this.mediaItems = this.mainMedia?.querySelectorAll('main-slider-slide') || [];
      this.thumbItems = this.thumbSlider?.querySelectorAll('thumb-slider-slide') || [];
      this.pageItems = this.pagenation?.querySelectorAll('button.page-media-item') || [];
    }

    bindEvents() {
      const mediaBtnNext = this.querySelector('.media-next');
      const mediaBtnPrev = this.querySelector('.media-prev');

      mediaBtnNext?.addEventListener('click', () => this.goToNext());
      mediaBtnPrev?.addEventListener('click', () => this.goToPrev());

      // Only add thumbnail event listeners if thumbItems exist
      if (this.thumbItems && this.thumbItems.length > 0) {
        this.thumbItems.forEach((thumb, index) => {
          thumb.addEventListener('click', () => this.scrollToMediaItem(index));
        });
      }
    
      this.pageItems.forEach((page, index) => {
        page.addEventListener('click', () => this.scrollToMediaItem(index));
      });
    
      let scrollTimeout = null;
      this.mainMedia?.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(() => this.handleScrollSnap(), 200);
      });
    
      const updateThumbSliderHeight = () => {
        if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
          this.thumbSlider.style.maxHeight = this.mainMedia.offsetHeight + 'px';
        } else if (this.thumbSlider) {
          this.thumbSlider.style.maxHeight = '';
        }
      };
      
      setTimeout(updateThumbSliderHeight, 200);
      
      window.addEventListener('resize', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateThumbSliderHeight, 200);
      });
    }

    handleScrollSnap() {
      const scrollLeft = this.mainMedia.scrollLeft;
      const itemWidth = this.mediaItems[0]?.clientWidth || 0;
      const offset = scrollLeft + this.mainMedia.offsetLeft;

      let closestIndex = 0;
      let minDiff = Infinity;
      this.mediaItems.forEach((item, i) => {
        const diff = Math.abs(item.offsetLeft - offset);
        if (diff < minDiff) {
          minDiff = diff;
          closestIndex = i;
        }
      });

      this.scrollToMediaItem(closestIndex);
    }

    goToNext() {
      if (this.activeIndex < this.mediaItems.length - 1) {
        this.scrollToMediaItem(this.activeIndex + 1);
      }
    }

    goToPrev() {
      if (this.activeIndex > 0) {
        this.scrollToMediaItem(this.activeIndex - 1);
      }
    }

    scrollToMediaItem(index) {
      if (!this.mediaItems.length) return;
    
      this.mediaItems[this.activeIndex]?.classList.remove('active');
      this.thumbItems[this.activeIndex]?.classList.remove('active');
      this.pageItems[this.activeIndex]?.classList.remove('active');
      
      const video_player = this.mediaItems[this.activeIndex].querySelector('video-player');
      
      this.activeIndex = index;
      
      if (video_player) {
        video_player.pauseAllVideo();
      }
    
      this.mediaItems[this.activeIndex]?.classList.add('active');
      this.thumbItems[this.activeIndex]?.classList.add('active');
      this.pageItems[this.activeIndex]?.classList.add('active');
    
      const scrollLeft = this.mediaItems[this.activeIndex].offsetLeft - this.mainMedia.offsetLeft;
      this.mainMedia.scrollTo({ left: scrollLeft, behavior: 'smooth' });

      try {
          if (this.thumbSlider && this.thumbVertical && window.innerWidth > 768) {
            const thumbScroll = this.thumbItems[this.activeIndex].offsetTop - this.thumbSlider.offsetTop - ((this.thumbSlider.clientHeight / 2) - (this.thumbItems[this.activeIndex].clientHeight / 2));
            this.thumbSlider.scrollTo({ top: thumbScroll, behavior: 'smooth' });  
          } else {
            const thumbScroll = this.thumbItems[this.activeIndex].offsetLeft - this.thumbSlider.offsetLeft - ((this.thumbSlider.clientWidth / 2) - (this.thumbItems[this.activeIndex].clientWidth / 2));
            this.thumbSlider.scrollTo({ left: thumbScroll, behavior: 'smooth' });  
          }
        } catch (error) {
          console.log('error in thumb scroll', error);
        }
    }

    refresh(index = 0) {
      this.activeIndex = index;
      this.cacheElements();
      this.bindEvents();
    }

    createCustomCarouselSlide(data, isThumbnail = false) {
      const slideTag = isThumbnail ? 'thumb-slider-slide' : 'main-slider-slide';
      const slideClass = isThumbnail ? 'thumb-media-item' : 'main-media-item';
      const slide = document.createElement(slideTag);
      slide.className = slideClass;
      slide.id = isThumbnail ? undefined : `wwai-media-${data.id}`;
  
      const img = document.createElement('img');
      img.src = isThumbnail ? `${data.src}&width=${data.width}` : data.src;
      img.alt = data.alt || "Image";
      img.width = data.width;
      img.height = data.height;
      img.loading = 'lazy';
      img.className = isThumbnail ? 'thumb-media-img' : 'main-media-img';
  
      const srcset = isThumbnail
        ? `${data.src}&width=${data.width} ${data.width}w`
        : [
            `${data.src}&width=352 352w`,
            `${data.src}&width=832 832w`,
            `${data.src}&width=1200 1200w`,
            `${data.src}&width=1920 1920w`,
            `${data.src}&width=2561 2561w`
          ].join(', ');
  
      img.setAttribute('srcset', srcset);
      img.setAttribute('sizes', '(min-width: 1536px) 1500px,(min-width: 1280px) 1250px,(min-width: 768px) 994px,(min-width: 768px) 708px,(min-width: 640px) 610px,100vw');
  
      if (isThumbnail) {
        slide.setAttribute('data-handle', `media-${data.id}`);
        slide.setAttribute('data-img-id', data.src);
      }
  
      slide.appendChild(img);
      return slide;
    }

    gotoSlide(index) {
      console.log('isReinitializing4', index);
      if (!this.mediaItems.length) return;

      // We need to make sure that we use custom media config in functionality.
      // we can improve this by making clear slide not delete the pre injected media.
      let index_to_use = index;
      if (this.has_pre_injected_media) {
        index_to_use = index + 1;
      }

      if (index_to_use < 0) {
        const resolvedIndex = this.mediaItems.length + index;
        this.scrollToMediaItem(resolvedIndex);
      } else {
        this.scrollToMediaItem(index_to_use);
      }
    }

    clearSlides() {
      this.mainMedia.innerHTML = '';
      if (this.thumbSlider) {
        this.thumbSlider.innerHTML = '';
      }
      this.mediaItems = [];
      this.thumbItems = [];
      this.activeIndex = 0;
    }
  }
  
  customElements.define('carousel-slider', CarouselSlider);
}
window.addEventListener('load', updateGridRows1);
window.addEventListener('load', updateGridRows2);
window.addEventListener('load', updateGridRows3);
window.addEventListener('load', updateGridRows4);
window.addEventListener('load', updateGridRows5);
window.addEventListener('load', updateGridRows6);
window.addEventListener('load', updateGridRows7);

// window.addEventListener('load', () => {
//   setTimeout(updateGridRows1, 100);
//   setTimeout(updateGridRows1, 500);
//   setTimeout(updateGridRows1, 500);
//   setTimeout(updateGridRows1, 500);
//   setTimeout(updateGridRows1, 500);
//   setTimeout(updateGridRows1, 500);
//   setTimeout(updateGridRows1, 500);
// });